export default (cb) => {
  import('select2').then(() => {
    import('select2/dist/js/i18n/nl').then(() => {
      cb();
    });
  });
};
